//regular
import { faShoppingBasket } from '@fortawesome/pro-regular-svg-icons/faShoppingBasket';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons/faAngleUp';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { faX } from '@fortawesome/pro-solid-svg-icons';
import { faStore } from '@fortawesome/pro-regular-svg-icons/faStore';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

//export array
export const icons = [faShoppingBasket, faAngleDown, faAngleUp, faBars, faX, faStore, faChevronDown, faChevronUp, faChevronLeft, faChevronRight];
